export { default } from './varient-skeleton.component';
